import { useTranslation } from 'react-i18next';

import { DesmosAssignment } from 'shared/api/assignment-service';
import { CardEventHandlers } from 'shared/api/event-service';
import { StreamCard } from 'shared/ui/stream-card';
import { isSSCAssignment } from 'shared/lib/utils';

export type Props = {
  classLabel: string;
  assignment: DesmosAssignment;
  eventHandlers: CardEventHandlers;
};

export const DesmosAssignmentCard = ({
  classLabel,
  assignment,
  eventHandlers,
}: Props) => {
  const { t } = useTranslation();

  const dashboardLink = assignment.content.dashboardURL;
  const activityLandingPageUrl = assignment.content.activityLandingPageURL;
  const thumbUrl = assignment.content.thumbURL;
  const title = assignment.content.title ?? '';
  const rosterTypeCaption = t('You assigned');
  const singleSessionTypeCaption = t('You generated a code for');
  const isSingleSessionCodeAssignment = isSSCAssignment(assignment);
  const caption = isSingleSessionCodeAssignment
    ? singleSessionTypeCaption
    : rosterTypeCaption;
  const rosterTypeStartDate = assignment.startDate ?? assignment.createdDate;
  const startDate = isSingleSessionCodeAssignment ? null : rosterTypeStartDate;

  return (
    <StreamCard
      assignment={assignment}
      classLabel={classLabel}
      content={assignment.content}
      caption={caption}
      eventHandlers={eventHandlers}
      startDate={startDate}
      dueDate={assignment.dueDate}
      viewWorkButtonUrl={dashboardLink}
      readyLinkToLesson={activityLandingPageUrl}
      readyThumbnailUrl={thumbUrl}
      readyLessonNumber={title}
    />
  );
};
